import {
    POST,
    GET,
    Delete,
    FormPost
} from "../util";

const operationUrl = "api/seller-debtor-management-operation/";
const inspectionUrl = "api/seller-debtor-management-inspection/";
const url = {
    inspection: {
        businessRelationCount: `${inspectionUrl}debtor-supplier-relation/count`,
        businessRelationList: `${inspectionUrl}debtor-supplier-relation/list`,
        debtorContactList: `${inspectionUrl}debtor-supplier-contact/:debtorId/list`,
        debtorInvitationMailParams: `${inspectionUrl}invite-debtor/:debtorId/get-params`,
        debtorSearch: `${inspectionUrl}debtor/search`,
        debtorCheck: `${inspectionUrl}debtor/check`,
        creditManagement: `${inspectionUrl}debtor-supplier-relation/:id/credit-management`,
        debtorDocuments: `${inspectionUrl}debtor-supplier-relation/:id/debtor-document`,
        contactList: `${inspectionUrl}debtor/`,

    },
    operation: {
        addBusinessRelation: `${operationUrl}business-relation/add`,
        submitBusinessRelation: `${operationUrl}business-relation/submit`,
        disableBusinessRelation: `${operationUrl}business-relation/:id/disable`,
        enableBusinessRelation: `${operationUrl}business-relation/:id/enable`,
        deleteBusinessRelation: `${operationUrl}business-relation/:id/delete`,
        saveContact: `${operationUrl}contact/save`,
        deleteContact: `${operationUrl}contact/:contactId/delete`,
        singleDebtorDocumentUpload: `${operationUrl}business-relation/debtor-documents/file-upload`,
        saveDebtorDocuments: `${operationUrl}business-relation/debtor-documents/save`,
        saveDebtorCredit: `${operationUrl}business-relation/credit-management/update`,
    },
};

const debtorManagementApi = {
    inspection: {
        countBusinessRelation: () => {
            return GET(url.inspection.businessRelationCount);
        },
        listBusinessRelation: (params = {}) => {
            return POST(url.inspection.businessRelationList, params);
        },
        listDebtorContact: (debtorId, params = {}) => {
            return POST(url.inspection.debtorContactList.replace(":debtorId", debtorId), params);
        },
        getDebtorInvitationMailParams: (debtorId) => {
            return GET(url.inspection.debtorInvitationMailParams.replace(":debtorId", debtorId));
        },
        debtorSearch: (params) => {
            return GET(url.inspection.debtorSearch, params, );
        },
        debtorCheck: (params) => {
            return POST(url.inspection.debtorCheck, params, );
        },
        getCreditManagement: (relationId) => {
            return GET(url.inspection.creditManagement.replace(":id", relationId));
        },
        getDebtorDocuments: (relationId) => {
            return GET(url.inspection.debtorDocuments.replace(":id", relationId));
        },
        debtorContact: (id) => {
            return GET(url.inspection.contactList + id + '/list-favorites', );
        },
    },

    operation: {
        addBusinessRelation: (params = {}) => {
            return POST(url.operation.addBusinessRelation, params)
        },
        submitBusinessRelation: (params = {}) => {
            return POST(url.operation.submitBusinessRelation, params)
        },
        disableBusinessRelation: (id, params = {}) => {
            return POST(url.operation.disableBusinessRelation.replace(":id", id), params)
        },
        enableBusinessRelation: (id, params = {}) => {
            return POST(url.operation.enableBusinessRelation.replace(":id", id), params)
        },
        deleteBusinessRelation: (id, params = {}) => {
            return Delete(url.operation.deleteBusinessRelation.replace(":id", id), params)
        },
        saveContact: (params = {}) => {
            return POST(url.operation.saveContact, params)
        },
        deleteContact: (contactId, params = {}) => {
            return Delete(url.operation.deleteContact.replace(":contactId",contactId), params)
        },
        uploadSingleDebtorDocument: (params = {}) => {
            return FormPost(url.operation.singleDebtorDocumentUpload, params);
        },
        saveDebtorCredit: (params = {}) => {
            return POST(url.operation.saveDebtorCredit, params);
        },
        saveDebtorDocuments: (params = {}) => {
            return POST(url.operation.saveDebtorDocuments, params);
        },
    }

};
export {
    debtorManagementApi
};